import { render, staticRenderFns } from "./PostSidebarWidgets.vue?vue&type=template&id=80937126&scoped=true&"
import script from "./PostSidebarWidgets.vue?vue&type=script&lang=js&"
export * from "./PostSidebarWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80937126",
  null
  
)

export default component.exports